module.exports = __webpack_public_path__ + "img/xqimg4.fec274b8.png";